<template>
    <div class="skeleton-wrapper">
        <div class="skeleton-line">
            <SkeletonLoader height="25px" border-radius="8px" />
            <SkeletonLoader height="54px" border-radius="68px" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import SkeletonLoader from '@malt/joy-entrypoint/src/vue/SkeletonLoader.vue';
</script>

<style lang="scss" scoped>
    .skeleton-wrapper {
        border: 1px solid var(--joy-color-neutral-30);
        border-radius: var(--joy-core-radius-3);
        padding: var(--joy-core-spacing-6);
        display: flex;
        flex-direction: column;
    }

    .skeleton-line {
        display: flex;
        flex-direction: column;
        gap: 9px;
    }
</style>
